<form
  [formGroup]="form"
  class="easy-form in-one-column"
  appScrollToInvalidControl
>
  <mat-form-field>
    <app-easy-checkbox
      formControlName="withDepositFee"
      [label]="TITLE + 'DEPOSITE_FEE' | translate"
      (ngModelChange)="changeDepositFee()"
    ></app-easy-checkbox>
  </mat-form-field>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-select
        formControlName="packingMethodSubType"
        [label]="TITLE + 'COLLECTION_TYPE' | translate"
        [options]="
          subtypes | toSelectOption: 'PACKAGING.NEW.SUBTYPE.COLLECTION.'
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        (ngModelChange)="onSubtypeChange($event)"
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-select
        formControlName="refId"
        [label]="
          (TITLE + 'COLLECTION' | translate) +
          (form.value.withDepositFee
            ? ''
            : ' (' + ('SHARED.OPTIONAL' | translate | lowercase) + ')')
        "
        [options]="
          packagingUnits$
            | async
            | toSelectOption: 'PACKAGING.NEW.SUBTYPE.COLLECTION.'
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="!form.value.withDepositFee"
      >
      </app-easy-select>
    </mat-form-field>

    <div class="d-flex align-items-end justify-content-between">
      <mat-form-field>
        <app-easy-input
          formControlName="amount"
          [label]="TITLE + 'UNIT_PER_COLLECTION' | translate"
          [outerSuffixLabel]="'PRODUCTS.UNIT.PIECES' | translate"
          type="number"
          [step]="1"
          [min]="1"
          [maxDecimals]="0"
        >
        </app-easy-input>
      </mat-form-field>

      <ng-container *ngIf="showLevelButtons && !readOnly">
        <button
          type="button"
          *ngIf="form.enabled"
          mat-icon-button
          color="primary"
          class="stroked"
          (click)="cancel()"
          [matTooltip]="'SHARED.CANCEL' | translate"
          matTooltipPosition="above"
        >
          <mat-icon>close</mat-icon>
        </button>
        <button
          type="button"
          mat-icon-button
          class="stroked"
          *ngIf="last && form.disabled"
          (click)="onDelete()"
          color="warn"
          [matTooltip]="'SHARED.DELETE' | translate"
          matTooltipPosition="above"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </ng-container>
    </div>
  </div>
  <mat-form-field *ngIf="last">
    <app-easy-checkbox
      class="mb-4"
      formControlName="unique"
      (ngModelChange)="onUniqueChange($event)"
      [label]="'PRODUCTS.COLLECTION_UNIT.UNIQUE' | translate"
    ></app-easy-checkbox>
  </mat-form-field>

  <app-product-variant
    *ngIf="form.value.unique"
    [groupName]="'productVariationData'"
  ></app-product-variant>

  <div
    *ngIf="!readOnly"
    class="collection-buttons d-flex flex-column align-items-end align-self-end gap-4"
    [ngClass]="last ? 'mb-4' : 'mb-5'"
  >
    <ng-container *ngIf="showLevelButtons">
      <ng-container *ngIf="form.disabled; else saveButton">
        <button
          type="button"
          [matTooltip]="'SHARED.EDIT' | translate"
          matTooltipPosition="above"
          mat-icon-button
          class="stroked"
          color="primary"
          (click)="onEdit()"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </ng-container>
      <ng-template #saveButton>
        <button
          type="submit"
          *ngIf="last; else iconSave"
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
        >
          {{
            (form.value.unique
              ? "PRODUCTS.PRODUCT_VARIANT.SAVE_VARIANT"
              : "PRODUCTS.COLLECTION_UNIT.SAVE_COLLECTION"
            ) | translate
          }}
        </button>
        <ng-template #iconSave>
          <button
            type="submit"
            mat-raised-button
            color="primary"
            [matTooltip]="'SHARED.SAVE' | translate"
            matTooltipPosition="above"
            (click)="onSubmit()"
          >
            <mat-icon>save</mat-icon>
          </button>
        </ng-template>
      </ng-template>
    </ng-container>
  </div>
</form>
